import { render } from "./altTable.vue?vue&type=template&id=03137f6c"
import script from "./altTable.vue?vue&type=script&lang=js"
export * from "./altTable.vue?vue&type=script&lang=js"

import "./altTable.vue?vue&type=style&index=0&id=03137f6c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__